var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { List, ListBullet, ListItem, Paragraph } from '../Common';
import { TutorialSection } from './TutorialSection';
var INTRO_TUTORIAL_ITEMS = [
    'What Happy Numbers is',
    'The Happy Numbers approach to teaching math',
    'Student learning experience — motivation and individualization',
    'Launching Happy Numbers',
];
var ScParagraph = styled(Paragraph).withConfig({ displayName: "ScParagraph", componentId: "sc-322tjv" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-bottom: 10px;\n"], ["\n  margin-bottom: 10px;\n"])));
var IntroTutorial = function (props) {
    return (_jsxs(TutorialSection, __assign({}, props, { title: 'Get to know Happy Numbers, your new math assistant!', video: 'intro', buttonLabel: 'Watch 18-minute Tutorial', reverse: true }, { children: [_jsxs(ScParagraph, { children: ["Dive into this succinct 18-minute tutorial at your", _jsx("br", {}, void 0), "convenience to learn the basics:"] }, void 0), _jsx(List, { children: INTRO_TUTORIAL_ITEMS.map(function (item, index) { return (_jsxs(ListItem, { children: [_jsx(ListBullet, {}, void 0), item] }, index)); }) }, void 0)] }), void 0));
};
export { IntroTutorial, INTRO_TUTORIAL_ITEMS };
var templateObject_1;
